export default function vibeCarouselController() {
  const section = document.querySelector('.vibe-carousel');

  if (!section) {
    return;
  }

  const swiperElement = section.querySelector('.swiper');

  const swiper = new Swiper(swiperElement, {
    init: false,
    slidesPerView: 3,
    loop: true,
    scrollbar: {
      el: section.querySelector('.swiper-scrollbar'),
    },
    navigation: {
      nextEl: section.querySelector('.swiper-button-next'),
      prevEl: section.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 48,
      },
    },
  });

  whenInViewport(swiperElement, () => {
    swiper.init();
  });
}
